import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import './styles.scss';

const propTypes = {

};

const contextTypes = {
  router: PropTypes.object,
};

const defaultProps = {

};

class SearchView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      results: [],
      query: '',
    };
    this.updateQuery = this.updateQuery.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.context.router.params.term) {
      const term = this.context.router.params.term;
      if (this.state.query.length === 0 && term !== this.state.query) {
        this.setState({ query: this.context.router.params.term });
      }
    }
  }

  handleKeyPress(e) {
    if (e.code === 'Enter') {
      browserHistory.push(`/search/${encodeURIComponent(this.state.query)}`);
    }
  }

  submitSearch() {
    browserHistory.push(`/search/${encodeURIComponent(this.state.query)}`);
  }

  updateQuery(e) {
    this.setState({ query: e.target.value });
  }

  render() {
    const { query } = this.state;
    return (
      <div className="input-group border border-light rounded-pill">
        <input
          id="search-input"
          type="text"
          className="form-control form-control-sm input-text bg-transparent text-white border-0"
          placeholder="Search Explore..."
          aria-label="Search"
          aria-describedby="search"
          value={query}
          onChange={this.updateQuery}
          onKeyUp={this.handleKeyPress}
        />
        <div className="input-group-append">
          <button className="btn text-light btn-sm border-0" type="button" disabled={query.length === 0} onClick={this.submitSearch}>
            <i className="fa fa-search" />
          </button>
        </div>
      </div>
    );
  }
}

SearchView.propTypes = propTypes;
SearchView.contextTypes = contextTypes;
SearchView.defaultProps = defaultProps;

export default SearchView;
